<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-memo`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 3a1 1 0 011 1v40a1 1 0 01-1 1H8a1 1 0 01-1-1v-9H4a1 1 0 01-1-1v-2a1 1 0 011-1h3v-5H4a1 1 0 01-1-1v-2a1 1 0 011-1h3v-5H4a1 1 0 01-1-1v-2a1 1 0 011-1h3V4a1 1 0 011-1h36zM28 7H11v6h3a1 1 0 011 1v2a1 1 0 01-1 1h-3v5h3a1 1 0 011 1v2a1 1 0 01-1 1h-3v5h3a1 1 0 011 1v2a1 1 0 01-1 1h-3v6h17V7zm4 0h9v34h-9V7z"/></svg>
</template>
<script>

export default {
  name: 'IconMemo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
